import React from 'react'

const FullWidthImage = ({ content }) => {
    const { image } = content

    if (!content) {
        return null
    }

    return (
        <div className="container">
            <div className={`content-band full-width-image`}>
                <img src={image?.url} alt={image?.alt} />
            </div>
        </div>
    )
}

export default FullWidthImage


